var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-ajax-dropdown',{attrs:{"url":`/api/members`,"value":_vm.selectedResource,"placeholder":_vm.placeholder,"query":_vm.query,"blacklist":_vm.blacklist,"disabled":_vm.isLoading,"label":"name","trackBy":"id","allowEmpty":true},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }